(function() {
    'use strict';
    var trackingUtils = require('../modules/utils/tracking.utils');
    var tagManagement = require('../modules/utils/tag_management.utils');
    const accountBlockedFactory = require('components/user_area/account_blocked/js/main');
    const createWidgetLoader = require('components-framework/widget/create_widget_loader');

    Odigeo.Router.handlers.accountblocked = function() {
        const widgetLoader = createWidgetLoader({
            accountBlocked: ['account-blocked', accountBlockedFactory],
        });
        var page = 'accountblocked';

        $('#page').removeClass().addClass(page);

        Odigeo.Session.set('page', 'accountblocked');

        Odigeo.Router.eventController = $.extend(Odigeo.Router.eventController,
            Odigeo.Router.handlers.globalEventController, Odigeo.Router.handlers.userEventController);
        Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController, {});

        Odigeo.Router.eventController.execute();

        widgetLoader.get('accountBlocked');

        // Analytics: virtual page tracking
        trackingUtils.trackPage('login/account_blocked', {
            funnel: false,
        });
        tagManagement.updateDatalayer();

        Odigeo.Utils.sessionTimer.reset();
    };
}());
